import { render } from "./SectionComponent.vue?vue&type=template&id=244f10ca&scoped=true&ts=true"
import script from "./SectionComponent.vue?vue&type=script&lang=ts"
export * from "./SectionComponent.vue?vue&type=script&lang=ts"

import "./SectionComponent.vue?vue&type=style&index=0&id=244f10ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244f10ca"]])

export default __exports__